import axios from 'axios'
import { getApiUrl } from './utils'

// Fallback auth for browsers that block cross-site cookies (iOS Safari with
// tracking prevention, private browsing, some Android browsers). The session
// cookie stays the primary mechanism; this mirrors the token in localStorage
// and sends it as an Authorization header, which the backend also accepts.

const STORAGE_KEY = 'storyfy_session_token'

export function getSessionToken(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function setSessionToken(token?: string | null) {
  if (!token) return
  try {
    window.localStorage.setItem(STORAGE_KEY, token)
  } catch {
    // storage unavailable (private mode quota etc.) — cookie auth still applies
  }
}

export function clearSessionToken() {
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

const API = getApiUrl()

axios.interceptors.request.use((config) => {
  const token = getSessionToken()
  if (token && config.url?.startsWith(API) && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
